import { siteApiSlice } from "../../../../app/siteApiSlice";
import { PromptUsageFilteredByCourseViewModel } from "./PromptUsageFilteredByCourseViewModel";
import { PromptUsageFilteredByCourseAndPromptViewModel } from "./PromptUsageByCourseAndPromptViewModel";

export const coursePromptReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		coursePromptReport: build.query<
			PromptUsageFilteredByCourseViewModel,
			{ writerId?: number; courseId?: number }
		>({
			query: (arg) => {
				const { writerId, courseId } = arg;
				return {
					url: `/prompt-report`,
					params: { writerId, courseId },
				};
			},
			providesTags: ["CurrentCourse"],
		}),
		coursePromptByPromptReport: build.query<
			PromptUsageFilteredByCourseAndPromptViewModel,
			{ promptId: number; courseId: number }
		>({
			query: (arg) => {
				const { promptId, courseId } = arg;
				return {
					url: `/prompt-report/${promptId}`,
					params: { courseId },
				};
			},
			providesTags: ["CurrentCourse"],
		}),
	}),
});

export const { useCoursePromptReportQuery, useCoursePromptByPromptReportQuery } =
	coursePromptReportApiSlice;
